import type { ReactNode } from 'react';

export interface SectionProps {
  readonly id: string;
  readonly label: string;
  readonly children: ReactNode;
}

/**
 * One public-site section.
 *
 * The heading is sticky and visible only below the split breakpoint: above it the left
 * column's nav does that job. Sticky works here precisely because `body` uses
 * `overflow-x: clip` rather than `hidden` — `hidden` would create a scroll container and
 * silently break it.
 */
export function Section({ id, label, children }: SectionProps) {
  return (
    <section id={id} aria-label={label} className="mb-24 scroll-mt-20 last:mb-0">
      <h2 className="sticky top-0 z-20 -mx-6 mb-[18px] bg-bg/70 px-6 py-3.5 text-[11.5px] font-bold uppercase tracking-[0.18em] text-text backdrop-blur-md split:hidden">
        {label}
      </h2>
      {children}
    </section>
  );
}
